"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExperimentEvaluationRule = isExperimentEvaluationRule;
exports.ensureExperimentRootFilter = ensureExperimentRootFilter;
exports.stripExperimentRootFilter = stripExperimentRootFilter;
exports.normalizeEvaluationRuleTarget = normalizeEvaluationRuleTarget;
const observationForEval_1 = require("./observationForEval");
const types_1 = require("./types");
const EXPERIMENT_ROOT_FILTER_COLUMN = "isExperimentItemRootSpan";
// Persisted dataset evaluators used both the display name and the legacy
// dataset-table id. Keep that storage compatibility independent of UI copy.
const LEGACY_EVENT_FILTER_COLUMN_ALIASES = {
    Dataset: "experimentDatasetId",
    datasetId: "experimentDatasetId",
};
const experimentRootFilter = {
    type: "boolean",
    column: EXPERIMENT_ROOT_FILTER_COLUMN,
    operator: "=",
    value: true,
};
function isExperimentEvaluationRule(params) {
    return (params.targetObject === types_1.EvalTargetObject.EXPERIMENT ||
        params.filter.some((filter) => filter.column === EXPERIMENT_ROOT_FILTER_COLUMN &&
            filter.type === "boolean" &&
            filter.operator === "=" &&
            filter.value === true));
}
function ensureExperimentRootFilter(filter) {
    return [
        ...filter.filter((entry) => entry.column !== EXPERIMENT_ROOT_FILTER_COLUMN),
        experimentRootFilter,
    ];
}
function stripExperimentRootFilter(filter) {
    return filter.filter((entry) => entry.column !== EXPERIMENT_ROOT_FILTER_COLUMN);
}
function normalizeEventFilterColumns(filter) {
    return filter.map((entry) => {
        const inputColumn = LEGACY_EVENT_FILTER_COLUMN_ALIASES[entry.column] ?? entry.column;
        const column = observationForEval_1.eventsEvalFilterColumns.find((candidate) => candidate.id === inputColumn ||
            candidate.name === inputColumn ||
            candidate.aliases?.includes(inputColumn));
        return column && column.id !== entry.column
            ? { ...entry, column: column.id }
            : entry;
    });
}
function normalizeEvaluationRuleTarget(params) {
    const normalizedParams = params.targetObject === types_1.EvalTargetObject.EVENT ||
        params.targetObject === types_1.EvalTargetObject.EXPERIMENT
        ? { ...params, filter: normalizeEventFilterColumns(params.filter) }
        : params;
    if (!isExperimentEvaluationRule(normalizedParams))
        return normalizedParams;
    return {
        targetObject: types_1.EvalTargetObject.EVENT,
        filter: ensureExperimentRootFilter(normalizedParams.filter),
    };
}
